import { Avatar, AvatarFallback } from '@neo/primitives/avatar'
import { BadgeWithTooltip } from '@neo/primitives/badge-with-tooltip'
import type { LiveAgent } from 'v2/types/api/conversations'
import { TransferButtons } from './transfer-buttons'

interface AgentItemProps {
  agent: LiveAgent
  onTransfer: (type: 'warm' | 'cold') => void
  isDisabled: boolean
}

export const AgentItem = ({ agent, onTransfer, isDisabled }: AgentItemProps) => {
  const initials = `${agent.account_first_name[0]}`.toUpperCase()

  return (
    <div className="flex items-center p-2 px-1 overflow-hidden gap-2 group cursor-default hover:bg-accent rounded-md border-b border-b-st2 last:border-b-0">
      <Avatar className="h-7 w-7 text-s-400">
        <AvatarFallback className="bg-hv1 text-secondary">{initials}</AvatarFallback>
      </Avatar>
      <div className="overflow-hidden">
        <div className="text-p-400 flex items-center gap-2">
          <div className="truncate">
            {`${agent.account_first_name} ${agent.account_last_name}`.trim()}
          </div>
          <div>
            {agent.teams.length > 0 && (
              <BadgeWithTooltip
                selectedItemsLength={agent.teams.length}
                items={agent.teams}
                moreText="team"
                findFunction={(teams) => teams}
                renderer={(teams) => teams.map((team) => team.team_name).join(', ')}
              />
            )}
          </div>
        </div>
        <div className="text-s-400 text-tertiary truncate">{agent.email}</div>
      </div>
      <TransferButtons onTransfer={onTransfer} isDisabled={isDisabled} prefix="agent-" />
    </div>
  )
}
